/**
 * ProdBanner.js — top-of-page banner shown only when
 * REACT_APP_ENV=production is baked into the build (HB-17, §5.BV).
 *
 * Render gate: IS_PROD === false -> render nothing.
 *
 * IS_PROD is set at build time from process.env.REACT_APP_ENV via the
 * Dockerfile ARG. Local dev and staging builds don't set it, so the banner
 * never renders there.
 *
 * Position is in-flow (no `position: fixed`), matching StagingBanner so the
 * shared LAYOUT_TOP_OFFSET in ../config.js compensates exactly once for
 * either env. PROD and staging cannot both fire simultaneously because
 * REACT_APP_ENV is a single string.
 *
 * Color #DC2626 is the design-system `danger` token (docs/design-system.md
 * Grade D foreground). Red signals "real customer data — exercise care."
 */

import React from 'react';
import { IS_PROD, ENV_BANNER_PX } from '../config';

function ProdBanner() {
  if (!IS_PROD) return null;

  return (
    <div
      style={{
        height: ENV_BANNER_PX,
        background: '#DC2626',
        color: '#FFFFFF',
        textAlign: 'center',
        lineHeight: `${ENV_BANNER_PX}px`,
        fontSize: '0.875rem',
        fontWeight: 600,
        letterSpacing: '0.04em',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
      }}
    >
      PRODUCTION: REAL CUSTOMER DATA
    </div>
  );
}

export default ProdBanner;
